import styled from 'styled-components'

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    background:#002666;

    @media (max-width: 768px) {
      display: grid;
      width: 500px;
    }


    .signup-form-holder{
        border:solid gray 2px;
        border-radius: 10px;
        width: 60%;
        margin: 50px auto;
        height: 600px;
        display:flex;
        justify-content:center;
        align-items:center;
        background:#f9f9f9;

        @media (max-width: 768px) {
          width: 90%;
       }
    }
    .signup-form{
        display:flex;
        height:60%;
        justify-content:space-between;
        align-items:center;
        flex-direction:column;


    }
    .email-form{

        input{
                border: 2px solid #303030;
                border-radius: 10px;
                width: 100%;
                height: 80px;
                font-size: 24px;
                padding-left: 20px;
                color: #bcbcbc;

        }
    }
    .password-form{
        input{
                border: 2px solid #303030;
                border-radius: 10px;
                width: 100%;
                height: 80px;
                font-size: 24px;
                padding-left: 20px;
                color: #bcbcbc;
        }
    }

    button{
            border: none;
            padding: 10px 40px;
            background: #ce1720;
            color: #fff;
            border-radius: 10px;
            font-size: 24px;
            font-weight: bold;
    }

`
